<template>
    <div v-if="block.display"
    style="z-index:9999;" 
        class="home-block" 
        v-observe-visibility="{
            callback: visibilityChanged,
            once: true
        }" :id="block.elementId">
        <h2 v-if="showTitle" v-html="!isLoading ? block.title : '&nbsp;'"></h2>
        <div v-if="isLoading" class="home-slick-mobile skeleton-box"></div>
        <VueSlickCarousel 
            v-if="!isLoading && block.items" 
            :accessibility="true"
            :infinite="true" 
            :slidesToShow="1" 
            :dots="true" 
            :arrows="false" 
            :slidesToScroll="1"
            :swipeToSlide="true"
            class="home-slick-mobile"
        >
            <template v-for="blockItem in block.items">
                <div v-if="blockItem.type == 'advantage'" :key="blockItem.key">
                    <BlockImage :classNames="'w-100 h-100'" :classNamesBox="'w-100 h-100'" :isScrolled="true" :image="blockItem.image" :title="'Prozis'"></BlockImage>
                </div>   
                <div v-else :key="blockItem.key" @click="gotoUrl(blockItem.url)">
                    <Mub :blockProduct="blockItem">
                        <a :href="blockItem.url" class="w-100 h-100 position-absolute" :aria-label="blockItem.name">&nbsp;</a>
                        <BlockImage :classNames="'w-100 h-100'" :classNamesBox="'w-100 h-100'" :loadingStyles="{height: '100vw !important'}" :isScrolled="true" :image="blockItem.image" :title="blockItem.name" :imageSrcSet="blockItem.image2x"></BlockImage>
                        <div class="shadow-bottom w-100 b-0">
                            <div class="row w-100 shadow-bottom-content p-absolute b-0 ml-0">
                                <div class="col name-label-container">
                                    <a class="product-label" :href="blockItem.url">
                                        <span class="name-label pr-2" v-html="blockItem.name"></span>
                                        <span v-if="blockItem.subtitle" class="name-label extra" v-html="blockItem.subtitle"/>
                                    </a>
                                </div>
                                <div class="col-auto p-0 pr-2">
                                    <p class="price-strikethrough mb-0">{{blockItem.priceCrossed}}</p>
                                    <p class="price-label">{{blockItem.price}}</p>
                                </div>
                            </div>
                        </div>
                        <BlockLabel v-if="(showPromoLabel && blockItem.label)" :label="blockItem.label"  :timeCounter="blockItem.timeCounter" />
                        <BlockLikes v-if="blockItem.likes" :likes="blockItem.likes" :rank="blockItem.ranking" :label-rank="blockItem.rankingLabel" :ranking-css-class="blockItem.rankingCssClass" :isDesktop="block.isDesktop"></BlockLikes>
                        <div v-if="numeration && blockItem.numeration" class="slider-numeration">
                            {{blockItem.numeration}}
                        </div>
                    </Mub>
                </div>
            </template>
            <Mub v-if="!isLoading && block.hasDiscovery" :rawData="block.mubDataViewMore">
                <div class="slider-item slider-item-discovery" @click="gotoUrl(block.discovery.url)">
                    <div class="top-shadow"></div>
                    <div class="slider-item-content slider-box-view-more">
                        <div class="w-100 text-center discovery-title">{{block.discovery.title}}</div>
                        <div><a class="discovery" :href="block.discovery.url">{{block.discovery.label}}</a></div>
                    </div>
                    <div class="bottom-shadow"></div>
                </div>   
            </Mub>    
        </VueSlickCarousel>
    </div>
</template>
 
<script>
import HomeBlock from '@/models/home-block';
import homeUtils from '@/Utilities/homeUtils';
import BlockImage from '../../Common/Partials/BlockImage';
import BlockLabel from '../Partials/BlockLabel';
import BlockLikes from '../../Common/Partials/BlockLikes';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import Mub from '@/components/Mub';

export default {
    components: { 
        BlockImage,
        BlockLabel,
        VueSlickCarousel,
        BlockLikes,
        Mub,
    },
    props:{
        block:{
            type: HomeBlock
        },
        showTitle:{
            type: Boolean,
            default: true
        },
        showPromoLabel:{
            type: Boolean,
            default: true
        },
        numeration:{
            type: Boolean,
            default: false
        },
    },
    data(){
        return{
            inViewPort: false,
            isScrolled: false
        }
    },
    computed: {
        isLoading(){
            return this.block && this.block.isLoading;
        }
    },
    methods: {
        visibilityChanged(isVisible){
            this.inViewPort = isVisible;
            if(isVisible){
                this.block.load();
            }
        },
        gotoUrl(url){
            homeUtils.gotoUrl(url,this.block);
        },
    }
}
</script>